import common from '../common/consignado'

export default (key) => {
  const commonParameters = common()

  const payloadsMap = {
    'carrossel:1': {
      custom_path: '/emprestimo/consignado/formalizacao/sucesso',
      detail: 'carrossel:1',
      ...commonParameters
    },
    'carrossel:2': {
      custom_path: '/emprestimo/consignado/formalizacao/sucesso',
      detail: 'carrossel:2',
      ...commonParameters
    },
    'carrossel:3': {
      custom_path: '/emprestimo/consignado/formalizacao/sucesso',
      detail: 'carrossel:3',
      ...commonParameters
    },
    'carrossel:4': {
      custom_path: '/emprestimo/consignado/formalizacao/sucesso',
      detail: 'carrossel:4',
      ...commonParameters
    }
  }

  return payloadsMap[key] ?? {}
}
